import React from 'react';
import { Badge, Card } from './AdminPanelPrimitives';

export const AdminReferralsPanel = ({ referrals, onApprove }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
    {referrals.length === 0 && (
      <p style={{ textAlign: 'center', color: '#999', padding: 20 }}>No referrals</p>
    )}
    {referrals.map((r) => (
      <Card key={r.id}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
          <p style={{ fontSize: 14, fontWeight: 700, margin: 0 }}>
            {r.details?.venue_name || r.details?.referred_name || 'Referral'}
          </p>
          <Badge
            text={r.status}
            color={r.status === 'approved' ? 'green' : r.status === 'rejected' ? 'red' : 'blue'}
          />
        </div>
        <p style={{ fontSize: 12, color: '#666', margin: 0 }}>Type: {r.referral_type}</p>
        {r.status === 'pending' && (
          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <button
              onClick={() => onApprove(r.id)}
              style={{
                padding: '6px 14px', borderRadius: 8, border: 'none',
                cursor: 'pointer', background: '#00C853', color: '#FFF',
                fontWeight: 700, fontSize: 13,
              }}
            >
              Approve
            </button>
          </div>
        )}
      </Card>
    ))}
  </div>
);
